<template>
  <div
    class="pa-4"
    :class="{
      alert: importStatus == 'FAILURE',
      'bg-primary-light': importStatus != 'FAILURE'
    }"
  >
    <div class="d-flex" data-test="eventResultImport">
      <div class="mr-5">
        <v-progress-circular
          v-if="['QUEUED', 'PROCESSING'].includes(importStatus)"
          :size="36"
          indeterminate
          color="black"
        />
      </div>

      <template v-if="importStatus == 'QUEUED'">
        {{
          $t(
            "events:EventPage.results.alerts.resultsQueued",
            "Results have been received from the scoring system and waiting in a queue to be processed. Check results import log for more information."
          )
        }}
      </template>
      <template v-else-if="importStatus == 'PROCESSING'">
        {{
          $t(
            "events:EventPage.results.alerts.resultsBeingProcessed",
            "The imported results are are currently being processed. Check results import log for more information."
          )
        }}
      </template>
      <template v-else-if="importStatus == 'PROCESSED'">
        {{
          $t(
            "events:EventPage.results.alerts.resultsProcessed",
            "The imported results processed. Check results import log for more information."
          )
        }}
      </template>
      <template v-else-if="importStatus == 'FAILED'">
        {{
          $t(
            "events:EventPage.results.alerts.resultsProcessingFailed",
            "Processing of results failed. Check results import log for errors and if you need help to resolve the situation, please contact technical support."
          )
        }}
      </template>
    </div>

    <div v-if="showLogsButton" class="text-end">
      <v-btn variant="outlined" @click="$emit('scroll-log')">
        <v-icon start> $iconClock </v-icon
        >{{
          $t(
            "events:EventPage.results.alerts.checkResultsImportLog.button",
            "Check log"
          )
        }}
      </v-btn>
    </div>
  </div>
</template>
<script setup>
// name: "ResultsImportPolling"
defineProps({
  importStatus: {
    type: String,
    required: true
  },
  showLogsButton: {
    type: Boolean,
    required: true
  }
});

defineEmits(["scroll-log"]);
</script>
